import { useContext } from 'react'
import { object } from 'prop-types'
import { utils } from '@digital-commerce/shared-utils'
import localeContext from '../../../contexts/Locale'
import useTranslate from '../../../hooks/useTranslate'
import {
  buildOrbitBIBPendingDataList,
  buildOrbitRecurringCreditsList,
  getMobilityPlan
} from '../../../utils/mobility'
import ItemsPrice from '../../molecules/CartItem/PriceBreakdown/ItemsPrice'
import PriceBreakdownContainer from '../../molecules/CartItem/PriceBreakdown/PriceBreakdownContainer'
import {
  buildCreditsAndDiscountsList,
  buildOtherChargesList,
  buildRecurringDiscountList
} from './utils'
import NameAndPrice from '../../atoms/ItemDetails/NameAndPrice'
import HeadingWithSubItems from '../../molecules/CartItem/PriceBreakdown/HeadingWithSubItems'
import FinalPrice from '../../molecules/CartItem/PriceBreakdown/FinalPrice'
import { OtherChargesAndCreditsContainer } from '../../molecules/CartItem/PriceBreakdown'
import { buildVasAddOnsList } from '../../../utils/display'

const { getMonthlyTotalPrice } = utils.cart

const OfferDetails = ({ byod }) => {
  const { lang } = useContext(localeContext)
  const translate = useTranslate()
  const monthlyTotalPrice = getMonthlyTotalPrice(byod)?.subTotal
  const plan = getMobilityPlan(byod)
  const recurringDiscountsData = buildRecurringDiscountList(byod, plan, lang)
  const vasAddonsData = buildVasAddOnsList({ offer: byod, translate, lang })
  const otherChargesData = buildOtherChargesList(byod, translate, lang)
  const otherCreditsAndDiscountsData = buildCreditsAndDiscountsList(byod, plan, lang)
  const orbitBIBPendingData = buildOrbitBIBPendingDataList(byod, lang, translate)
  const orbitRecurringData = buildOrbitRecurringCreditsList(byod, translate, lang)
  const pendingAmountsData = [...orbitBIBPendingData, ...orbitRecurringData]

  const recurringDiscounts = recurringDiscountsData?.map((discount) => (
    <NameAndPrice
      id={discount.id}
      key={discount.id}
      name={discount.name}
      price={discount.price}
      prefixIcon={discount.prefixIcon}
    />
  ))

  const vasAddons = (
    <HeadingWithSubItems subItems={vasAddonsData} headingText={translate('addons')} />
  )

  const otherCharges = (
    <HeadingWithSubItems
      subItems={otherChargesData}
      headingText={translate('additionalChargesAndCredits.additionalCharges')}
    />
  )

  const otherCreditsAndDiscounts = (
    <HeadingWithSubItems
      subItems={otherCreditsAndDiscountsData}
      headingText={translate('additionalChargesAndCredits.additionalCreditsAndDiscounts')}
    />
  )

  const pendingAmounts = (
    <HeadingWithSubItems
      subItems={pendingAmountsData}
      headingText={translate('additionalChargesAndCredits.pendingAmounts')}
    />
  )

  return (
    <>
      <PriceBreakdownContainer>
        <ItemsPrice items={[plan]} isRecurring />
        {recurringDiscounts}
        {vasAddons}
        <FinalPrice price={monthlyTotalPrice} isMonthly />
      </PriceBreakdownContainer>
      <OtherChargesAndCreditsContainer
        listData={[...otherChargesData, ...otherCreditsAndDiscountsData, ...pendingAmountsData]}
      >
        {otherCharges}
        {otherCreditsAndDiscounts}
        {pendingAmounts}
      </OtherChargesAndCreditsContainer>
    </>
  )
}

export default OfferDetails

OfferDetails.propTypes = {
  byod: object.isRequired
}
